import React from "react";

const ShiftRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.07372 2.08042L13.3464 7.83243C13.4052 7.89657 13.3597 8 13.2727 8H10.6C10.5448 8 10.5 8.04477 10.5 8.1V13.9C10.5 13.9552 10.4552 14 10.4 14H5.6C5.54477 14 5.5 13.9552 5.5 13.9V8.1C5.5 8.04477 5.45523 8 5.4 8H2.72732C2.64031 8 2.59481 7.89657 2.65361 7.83243L7.92628 2.08042C7.96592 2.03718 8.03408 2.03718 8.07372 2.08042Z",
  stroke: "currentColor",
  strokeOpacity: 0.5,
  strokeWidth: 1.1
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ShiftRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;